
import React from "react";
import { Layout } from "components";
import styles from "./unsubscribe.module.scss";
import { Footer } from "components/Footer";
import checkMark from "../../assets/img/checkmark-circle.svg";

export function UnsubscribeFinished() {

    const handleGoToNewAlert = () => {
        window.location.href = "/";
    }

    return (
        <>
            <Layout title={`Vamos sentir sua falta.`} subtitle={`Esperamos nos ver novamente em breve.`}>
                <div style={{ marginLeft: 74 }}>
                    <div style={{ marginBottom: 66 }}>
                        <img
                            src={checkMark}
                            alt="ok"
                            style={{ verticalAlign: "middle", display: "initial" }}
                        />
                        <span className={styles['text-body']}>E-mail descadastrado com sucesso.</span>
                    </div>
                    <p className={styles['text-manager-alerts']}>
                    Se preferir, você também pode <span onClick={handleGoToNewAlert}>criar um novo alerta.</span>
                    </p>
                </div>
            </Layout>
            <Footer />
        </>
    );
}
